module.exports = __webpack_public_path__ + "static/media/heart-icon-xs.55f6ba3e.svg";